import { useCallback, useEffect, useState } from "react";
import { NavBar } from "../components/general/NavBar"
import MeetingsComponent from '../components/Meetings/MeetingsComponent'
import { Footer } from "components/general/Footer"
import Sidebar from "components/Meetings/Sidebar";
import { toast } from "react-toastify";

export default function Meetings() {

  // get Config settings

  const url = process.env.REACT_APP_URL;
  const [config, setConfig] = useState(null);


  const getConfig = useCallback(async () => {
    try {
      const response = await fetch(`${url}/meetingsConfig`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const config = await response.json();
        setConfig(config);
      } else {
        console.error('Failed to fetch meetings config');
        toast.error('Failed to fetch meetings config', { position: 'bottom-left' });
      }
    } catch (error) {
      console.error('Error fetching meetings config:', error);
      toast.error(`Error fetching meetings config: ${error.message}`, { position: 'bottom-left' });
    }
  }, [url]);

  useEffect(() => {
    getConfig();
  }, [getConfig]);


  return (
    <>
      <NavBar pagename="Meetings" />
      <MeetingsComponent config={config} />
      <Footer />
      <Sidebar config={config} getConfig={getConfig} />
    </>
  )
}